// src/components/job-engine/ConnectionStatusBadge.tsx
import React from "react";
import { Stack, Text, Icon } from "@fluentui/react";

interface Props {
  isConnected: boolean;
}

const ConnectionStatusBadge: React.FC<Props> = ({ isConnected }) => {
  const color = isConnected ? "#107c10" : "#d83b01";
  const label = isConnected ? "Live" : "Polling";
  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 6 }}>
      <Icon iconName="CircleFill" styles={{ root: { color, fontSize: 10 } }} />
      <Text variant="small" styles={{ root: { color } }}>{label}</Text>
    </Stack>
  );
};

export default ConnectionStatusBadge;
